import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { apiClient } from "sessions/server";

export const Unsubscribe = () => {
    const { token } = useParams();
    const [status, setStatus] = useState("processing"); // processing, success, error
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        apiClient
            .post(`/users/unsubscribe/`, { uuid: token })
            .then((response) => {
                setStatus("success");
            })
            .catch((error) => {
                setStatus("error");
                setErrorMessage(
                    error.response?.data?.message ||
                    error.message ||
                    "Something went wrong. Please try again later."
                );
            });
    }, [token]);

    if (status === "processing") {
        return (
            <section className="container text-box">
                <h2 className="section-title">Processing...</h2>
                <p className="section-description">
                    Please wait while we unsubscribe you from our mailing list.
                </p>
            </section>
        );
    }

    if (status === "error") {
        return (
            <section className="container text-box">
                <h2 className="section-title">Error</h2>
                <p className="section-description">
                    {errorMessage}
                </p>
            </section>
        );
    }

    return (
        <section className="container text-box">
            <h2 className="section-title">Unsubscribed</h2>
            <p className="section-description">
                We're sorry to see you go! Your unsubscription has been
                confirmed, you can join our community again at any time.
            </p>
        </section>
    );
};
